import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IFilterOption } from '@rankmi/rankmi-table/dist/interfaces/filterProps'

import { joinKeys } from 'helpers/translations.helper'
import { IMainState } from 'store/states'
import { EnrolState, getTranslationEnrolStateKey } from 'enum'
import { prefixTranslation } from '../common'

interface Column extends IFilterOption {
  label: string
  type: string
  value: string
}

const { Approved, Denied, Pending, Absent, ExcusedAbsence } = EnrolState

export const useFiltersColumns = () => {
  const prefix = joinKeys(prefixTranslation, 'attributes')
  const prefixFilters = joinKeys(prefix, 'stateAdvanceList')

  const [filtersColumns, setFilterColumns] = useState<Column[]>([])
  const { t } = useTranslation()
  const { loading: profilesLoading } = useSelector(
    ({ lmsProfiles }: IMainState) => lmsProfiles
  )

  useEffect(() => {
    if (!profilesLoading) {
      setFilterColumns([
        {
          label: t(`${prefix}.user.name`),
          value: 'user_full_name',
          type: 'string',
        },
        {
          label: t(`${prefix}.state`),
          value: 'state',
          type: 'tagsList',
          list: [Approved, Denied, Pending, Absent, ExcusedAbsence].map(
            (value) => {
              const key = getTranslationEnrolStateKey(value)
              return {
                value: String(value),
                label: t(`${prefixFilters}.${key}`),
              }
            }
          ),
        },
        {
          label: t(`${prefix}.user.position`),
          value: 'user_position',
          type: 'string',
        },
      ])
    }
  }, [prefix, prefixFilters, profilesLoading, t])
  return filtersColumns
}
